import { ApiRequest, postItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import ODataUtil from 'utils/ODataUtil';

const reports_endpoint = "/Reports";

async function runReport(values, projectId, sysUserId) {
    const resourcePath = `${reports_endpoint}/Run`
    const params = ``
    values.SysuserId = sysUserId
    values.ProjectId = projectId
    const result = await postItem(resourcePath, params, values, false, true)
    return result
}

// TODO
//const runReport = async (values, projectId, sysUserId) => {
//    await new Promise(res => setTimeout(res, 1000));
//    const resourcePath = `${reports_endpoint}/Run`
//    const params = ``
//    const result = await postItem(resourcePath, params, formValues)
//    return {
//        success: false,
//        data: 'ok'
//    }
//}

// TODO
const scheduleReport = async (values, projectId, sysUserId) => {
    await new Promise(res => setTimeout(res, 1000));
    return {
        success: false,
        data: 'ok'
    };
}

export { runReport, scheduleReport };